import { useEffect, useCallback } from 'react';

import { Fn } from 'types/utils';

const useAppOnlineStatus = (onlineFn: Fn, offlineFn: Fn): void => {
  /**
   * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
   * it's not reliable to detect if the browser is currently online or offline
   * based on `navigator.onLine`.
   * As a work around,  we change the status upon `online` or `offline` events.
   */

  const handleOnlineStatus = useCallback(
    (event: Event) => {
      if (event.type === 'online') {
        onlineFn();
      } else {
        offlineFn();
      }
    },
    [onlineFn, offlineFn]
  );

  useEffect(() => {
    window?.addEventListener('online', handleOnlineStatus);
    window?.addEventListener('offline', handleOnlineStatus);

    return () => {
      window?.removeEventListener('online', handleOnlineStatus);
      window?.removeEventListener('offline', handleOnlineStatus);
    };
  }, [handleOnlineStatus]);
};

export default useAppOnlineStatus;
